import React, { useState } from 'react'

import { I_AccordionSection } from '../state/wpDataStore'
import { ContentExpander } from './ContentExpander'

const Accordion = ({ sections }: { sections: I_AccordionSection[] }) => {
  return (
    <ul className='accordion'>
      {sections.map((section, index) => {
        return <AccordionSection key={index} section={section} />
      })}
    </ul>
  )
}

const AccordionSection = ({ section }: { section: I_AccordionSection }) => {
  const { title, content } = section

  const [expanded, setExpanded] = useState(false)

  return (
    <li className='accordion__section'>
      <div className='accordion__section-header'>
        <button
          className='accordion__section-header-inner'
          onClick={() => {
            setExpanded(!expanded)
          }}
        >
          <span>{title}</span>
          <i
            className={`fa-solid ${expanded ? 'fa-angle-up' : 'fa-angle-down'}`}
          ></i>
        </button>
      </div>

      <ContentExpander expanded={expanded}>
        <>
          {content && (
            <div
              className='accordion__section-content'
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </>
      </ContentExpander>
    </li>
  )
}

export { Accordion }
